/**
 * All Case Studies - Simple show/hide filter
 */
(function() {
    'use strict';

    document.addEventListener('click', function(e) {
        const link = e.target.closest('.all-case-studies__filter-item');
        if (!link || !link.dataset.filter) return;

        e.preventDefault();

        const block = link.closest('[data-all-case-studies]');
        const slug = link.dataset.filter;

        block.querySelectorAll('.all-case-studies__filter-item').forEach(l => {
            l.classList.toggle('all-case-studies__filter-item--active', l.dataset.filter === slug);
        });

        block.querySelectorAll('.all-case-studies__card').forEach(card => {
            const cats = (card.dataset.categories || '').split(/\s+/).filter(Boolean);
            card.style.display = (slug === 'all' || cats.includes(slug)) ? '' : 'none';
        });

        const list = block.querySelector('.all-case-studies__list');
        if (list) list.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
})();